import { render } from "./CommentComponent.vue?vue&type=template&id=320c2270&scoped=true"
import script from "./CommentComponent.vue?vue&type=script&lang=js"
export * from "./CommentComponent.vue?vue&type=script&lang=js"

import "./CommentComponent.vue?vue&type=style&index=0&id=320c2270&scoped=true&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320c2270"]])

export default __exports__